import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';

import AntTree from './AntTree';

export default forwardRef(function (props, ref) {
    const tree = useRef();

    // const reload = (defaultObj) => {
    //     if (tree.current) tree.current.load(defaultObj, true);
    // };

    const selectedRows = () => {
        if (tree.current) return tree.current.selectedRows();
        return [];
    };

    const getSelectedObjectId = () => {
        if (tree.current) return tree.current.getSelectedObjectId();
        return null;
    };

    useImperativeHandle(ref, () => ({
        getSelectedObjectId: getSelectedObjectId,
        selectedRows: selectedRows
    }));

    var storageKey = props.name ? props.name : props.entityName ? props.entityName : props.API && props.API.entityName ? props.API.entityName : null;
    storageKey = storageKey ? 'setting-tree-' + storageKey : undefined;

    return (
        <React.Fragment>
            <AntTree
                ref={tree}
                API={props.API}
                url={props.url}
                table={props.table}
                dataSourceHelper={this}
                entityName={props.entityName}
                entityDisplay={props.entityDisplay}
                storageKey={storageKey}
                keyExpr={props.keyExpr}
                parentIdExpr={props.parentIdExpr}
                loadFunc={props.loadFunc}
                searchConditions={props.searchConditions}
                searchFields={props.searchFields}
                sortable={props.sortable}
                selectable={props.selectable}
                allowedPageSizes={props.allowedPageSizes}
                columns={props.columns}
                fields={props.fields}
                autoExpandAll={props.autoExpandAll}
                autoSelectParent={false}
                actionItems={props.actionItems}
                showActionBar={props.showActionBar}
                showRefresh={true}
                showEdit={props.showEdit}
                showDelete={props.showDelete}
                showAdd={props.showAdd}
                showImport={props.showImport}
                showDownload={props.showDownload}
                showFieldChooser={props.showFieldChooser}
                showSearchBar={props.showSearchBar}
                locationRefresh={props.locationRefresh}
                locationEdit={props.locationEdit}
                locationDelete={props.locationDelete}
                locationAdd={props.locationAdd}
                locationFilterBySelected={props.locationFilterBySelected}
                locationImport={props.locationImport}
                locationDownload={props.locationDownload}
                locationSearchBar={props.locationSearchBar}
                onEdit={props.onEdit}
                onDelete={props.onDelete}
                onImport={props.onImport}
                onAdd={props.onAdd}
            />
        </React.Fragment>
    );
});
